import PropTypes from 'prop-types';
import React from 'react';
import { useParams } from 'react-router';

import AdminBrowseCategoriesEditPage from 'app/components/admin/browse/categories/AdminBrowseCategoriesEditPage';

export function AdminBrowseCategoriesCreatePageRoute({ basePageRoute }) {
  const { localeCode, topLevelCategoryId } = useParams();

  return (
    <AdminBrowseCategoriesEditPage
      basePageRoute={basePageRoute}
      localeCode={localeCode}
      topLevelCategoryId={topLevelCategoryId}
    />
  );
}

AdminBrowseCategoriesCreatePageRoute.propTypes = {
  basePageRoute: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesCreatePageRoute;
